import { History } from "history";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  AdvisorId,
  AdvisorRequestConfig,
  RequestConfig,
} from "@fartherfinance/frontend/api/Types";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";
import useRequestAuth from "@src/multiCustodian/hooks/useRequestAuth";
import { State } from "@src/store";

interface UseAdvisorPageInitReturn {
  history: History;
  auth: AdvisorRequestConfig | null;
  requestAuth: RequestConfig | null;
  advisorId?: AdvisorId | null;
}

export function useAdvisorPageInit(): UseAdvisorPageInitReturn {
  const history = useHistory();
  const auth = useAdvisorRequestAuth();
  const requestAuth = useRequestAuth();
  const { advisorId } = useSelector((state: State) => ({
    advisorId: state.main_Reducer.cockroach_advisor_id,
  }));

  return {
    history,
    auth,
    requestAuth,
    advisorId,
  };
}
